// モバイルドロワーメニューの開閉
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["drawer", "overlay"]

  toggleMenu() {
    this.drawerTarget.classList.toggle("open")
    this.overlayTarget.classList.toggle("open")
  }
}
